export const SET_TASK_DETAILS = 'taskDetail/SET_TASK_DETAILS';
export const SET_TASK_ATTACHMENTS = 'taskDetail/SET_TASK_ATTACHMENTS';
export const ADD_TASK_NOTE = 'taskDetail/ADD_TASK_NOTE';
export const SET_HISTORY = 'taskDetail/SET_HISTORY';
export const RESET_REDUCER = 'taskDetail/RESET_REDUCER';
